// assets/upside-cart-bridge.js
// Simon 2026-10-03: one place between our scripts and whatever cart drawer is live.
// Today the drawer is the Rebuy Smart Cart; tomorrow it is our own assets/upside-cart.js (window.UDCart).
// Our widgets (FBT, sticky bar, product rows, ship bar, BMSM badge) call this instead of Rebuy, so
// swapping the drawer is one change here. Loaded early (not deferred) from layout/theme.liquid.
//
//   UDCartBridge.open()          refresh the drawer, then show it (UDCart > Rebuy > theme drawer > /cart)
//   UDCartBridge.refresh()       re-read the cart in the drawer, Promise
//   UDCartBridge.onChange(cb)    cb() after any cart change: 'ud:cart.change', 'rebuy:cart.change',
//                                theme 'cart:updated' / 'cart:refresh'. Debounced. Returns an unsubscribe.
//   UDCartBridge.add(items, src) POST /cart/add.js with line property _ud_src = src ('fbt', 'more-like-this'...),
//                                then fires 'ud:cart.change'. Promise of the add.js response.
//   UDCartBridge.tagForm(form, src)  sticky bar: puts properties[_ud_src] in the product form for the next submit.
//   UDCartBridge.changed(detail) fires 'ud:cart.change' on document.
//
// _ud_src (underscore = hidden at checkout and in the order confirmation) lets us measure what our widgets sell
// once Rebuy is gone. It is NOT added when the same variant is already in the cart, so the line merges
// instead of splitting in two.
(function () {
  'use strict';
  if (window.UDCartBridge) return;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var EVENTS = ['ud:cart.change', 'rebuy:cart.change', 'cart:updated', 'cart:refresh'];

  function changed(detail) {
    try { document.dispatchEvent(new CustomEvent('ud:cart.change', { detail: detail || {} })); } catch (e) {}
  }
  function rebuy() { return window.Rebuy || null; }

  function refresh() {
    try {
      if (window.UDCart && typeof window.UDCart.refresh === 'function') return Promise.resolve(window.UDCart.refresh());
      var R = rebuy();
      if (R && R.Cart && typeof R.Cart.fetchCart === 'function') {
        var p = R.Cart.fetchCart();
        return p && p.then ? p : new Promise(function (ok) { setTimeout(ok, 300); });
      }
    } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
    return Promise.resolve();
  }

  function show() {
    try { if (window.UDCart && typeof window.UDCart.open === 'function') { window.UDCart.open(); return true; } } catch (e) {}
    try { var R = rebuy(); if (R && R.SmartCart && typeof R.SmartCart.show === 'function') { R.SmartCart.show(); return true; } } catch (e) {}
    // theme drawer (Impulse listens for cart:open), else the cart page
    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      try { document.dispatchEvent(new CustomEvent('cart:build')); document.dispatchEvent(new CustomEvent('cart:open')); return true; } catch (e) {}
    }
    location.href = ROOT + 'cart';
    return false;
  }

  function open() {
    var go = function () { show(); };
    return refresh().then(go, go);
  }

  function onChange(cb) {
    var t = 0;
    var h = function () { clearTimeout(t); t = setTimeout(function () { try { cb(); } catch (e) {} }, 60); };
    EVENTS.forEach(function (n) { document.addEventListener(n, h); });
    return function () { EVENTS.forEach(function (n) { document.removeEventListener(n, h); }); };
  }

  function cartVariants() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { var s = {}; (c.items || []).forEach(function (i) { s[i.variant_id] = 1; }); return s; })
      .catch(function () { return null; });
  }

  function add(items, src) {
    var pre = src ? cartVariants() : Promise.resolve(null);
    return pre.then(function (inCart) {
      var body = items.map(function (it) {
        var o = { id: it.id, quantity: it.quantity || 1 };
        var props = Object.assign({}, it.properties || {});
        if (src && inCart && !inCart[it.id]) props._ud_src = src;
        if (Object.keys(props).length) o.properties = props;
        return o;
      });
      return fetch(ROOT + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: body }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (j) { changed({ source: src || '', items: body }); return j; });
    });
  }

  // Sticky bar: tag the next submit of the real product form. Removed after the add (or 5 s).
  function tagForm(form, src) {
    if (!form || !src) return Promise.resolve();
    var idEl = form.querySelector('[name="id"]');
    var vid = idEl && parseInt(idEl.value, 10);
    return cartVariants().then(function (inCart) {
      var old = form.querySelector('input[name="properties[_ud_src]"]');
      if (old) old.remove();
      if (!vid || !inCart || inCart[vid]) return;
      var inp = document.createElement('input');
      inp.type = 'hidden'; inp.name = 'properties[_ud_src]'; inp.value = src;
      form.appendChild(inp);
      // only for this one add: gone after the next cart change (or 5 s)
      var stop = onChange(function () { setTimeout(drop, 300); });
      var drop = function () { if (inp.parentNode) inp.remove(); stop(); };
      setTimeout(drop, 5000);
    });
  }

  window.UDCartBridge = { open: open, refresh: refresh, onChange: onChange, add: add, tagForm: tagForm, changed: changed };
})();
